import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  DescriptionAssetCollection,
} from '@bingads-webui-campaign-react/pmax-text-input';
import {
  TextTitle,
  ValidatedPanel,
  getPanelErrorProps,
} from '@bingads-webui-campaign/wizard-jumbo-card';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PANEL_KEYS } from './panel-keys';

export const DescriptionsPanel = ({
  descriptionsCardSummaryDetails,
  allAssetsExpand,
  icon,
  setAddNewDescriptionCallback,
  featureName,
  isOptional,
  ...rest
}) => {
  const i18n = useContext(I18nContext);

  return (
    <ValidatedPanel
      key={PANEL_KEYS.DESCRIPTIONS}
      title={<TextTitle
        titleKey={_TL_('Descriptions')}
        icon={icon}
        iconAltText={i18n.getString(_TL_('Descriptions'))}
        details={descriptionsCardSummaryDetails}
      />}
      attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
      actuationProps={{
        expand: allAssetsExpand,
        expandKey: PANEL_KEYS.DESCRIPTIONS,
      }}
      {...rest}
    >
      <DescriptionAssetCollection featureName={featureName} showDeleteButton setAddNewDescriptionCallback={setAddNewDescriptionCallback} isOptional={isOptional} />
    </ValidatedPanel>
  );
};

DescriptionsPanel.propTypes = {
  descriptionsCardSummaryDetails: PropTypes.shape({}).isRequired,
  allAssetsExpand: PropTypes.func.isRequired,
  icon: PropTypes.node.isRequired,
  setAddNewDescriptionCallback: PropTypes.func.isRequired,
  featureName: PropTypes.string.isRequired,
  isOptional: PropTypes.bool,
};

DescriptionsPanel.defaultProps = {
  isOptional: false,
};
